module.exports = __webpack_public_path__ + "static/media/cover_page.39e1231c.gif";